import { useState, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { encodeFilters } from './filterUrl';

export const useProductFilters = (initialFilters = {}, initialSortOrder = 'desc') => {
  const location = useLocation();
  const navigate = useNavigate();

  const [filters, setFilters] = useState(initialFilters);
  const [sortOrder, setSortOrder] = useState(initialSortOrder);

  const pageIndex = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const n = Number(queryParams.get('page'));
    return Number.isInteger(n) && n >= 1 ? n : 1;
  }, [location.search]);

  // Zapis zastosowanych filtrów do URL (param `f`) + reset strony na 1.
  // replace: true — zmiany filtrów nie zaśmiecają historii, ale URL listy w chwili
  // wejścia w produkt zawiera aktualne filtry, więc „Powrót" je odtwarza.
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    const queryParams = new URLSearchParams(location.search);
    const encoded = encodeFilters(newFilters);
    if (encoded) {
      queryParams.set('f', encoded);
    } else {
      queryParams.delete('f');
    }
    queryParams.set('page', '1');
    navigate({ search: queryParams.toString() }, { replace: true });
  };

  const handleSortChange = (order) => {
    setSortOrder(order);
  };

  const handlePageChange = (e, value) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set('page', value);
    navigate({ search: queryParams.toString() });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return {
    filters,
    sortOrder,
    pageIndex,
    setFilters: handleFilterChange,
    setSortOrder: handleSortChange,
    onPageChange: handlePageChange,
  };
};
